import api from "@/config/api";
import type { RequestOptions } from "@/shared/types/api.types";
import { API_ENDPOINTS } from "@/constants/api-endpoints";
import type {
  PageResponseDTO,
  PaginationParams,
} from "@/shared/types/pagination.types";
import type {
  SellerResponseDTO,
  SellerRequestDTO,
  SellerSearchParams,
} from "../types/seller.types";

export const sellerService = {
  list: async (
    params?: PaginationParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<SellerResponseDTO>> => {
    const response = await api.get<PageResponseDTO<SellerResponseDTO>>(
      API_ENDPOINTS.SELLERS.PAGINATED,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  search: async (
    params?: SellerSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<SellerResponseDTO>> => {
    const response = await api.get<PageResponseDTO<SellerResponseDTO>>(
      API_ENDPOINTS.SELLERS.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  /**
   * Busca de vendedores no escopo USER. O endpoint admin
   * (`/admin/sellers/search`) responde 403 para o role USER —
   * use este método em telas acessadas por usuários comuns.
   */
  searchUser: async (
    params?: SellerSearchParams,
    options?: RequestOptions,
  ): Promise<PageResponseDTO<SellerResponseDTO>> => {
    const response = await api.get<PageResponseDTO<SellerResponseDTO>>(
      API_ENDPOINTS.SELLERS_USER.SEARCH,
      { params, signal: options?.signal },
    );
    return response.data;
  },

  getById: async (
    id: number,
    options?: RequestOptions,
  ): Promise<SellerResponseDTO> => {
    const response = await api.get<SellerResponseDTO>(
      API_ENDPOINTS.SELLERS.BY_ID(id),
      { signal: options?.signal },
    );
    return response.data;
  },

  create: async (data: SellerRequestDTO): Promise<SellerResponseDTO> => {
    const response = await api.post<SellerResponseDTO>(
      API_ENDPOINTS.SELLERS.BASE,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: SellerRequestDTO,
  ): Promise<SellerResponseDTO> => {
    const response = await api.put<SellerResponseDTO>(
      API_ENDPOINTS.SELLERS.BY_ID(id),
      data,
    );
    return response.data;
  },

  remove: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.SELLERS.BY_ID(id));
  },
};
